/**
 * Translates a given key and replaces placeholders with provided values
 *
 * @param key - The translation key to look up in the window translations
 * @param replace - An object containing key-value pairs where key is the placeholder name (without ':')
 *                 and value is the replacement string
 * @returns The translated string with placeholders replaced, or the original key if translation is not found
 *
 * @example
 * // Assuming translation for "welcome" is "Hello :name!"
 * __("welcome", { name: "John" }) // Returns "Hello John!"
 */
var __ = function (key, replace) {
    var translation = getTranslationFromWindow(key);
    if (translation === null) {
        return key;
    }
    if (replace === undefined) {
        return translation;
    }
    Object.entries(replace).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        translation = translation.replace(":".concat(key), value);
    });
    return translation;
};
var getTranslationFromWindow = function (key) {
    var _a;
    if (!((_a = window.App) === null || _a === void 0 ? void 0 : _a.translations)) {
        return null;
    }
    var current = window.App.translations;
    var parts = key.split('.');
    for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
        var part = parts_1[_i];
        if (current == null || typeof current !== 'object') {
            return null;
        }
        current = current[part];
    }
    return typeof current === 'string' ? current : null;
};
export default __;
